import React from "react";
import styled, { css } from "styled-components";
import Switch from "@material-ui/core/Switch";
import { useMediaQuery, useTheme } from "@material-ui/core";
import Slider from "@material-ui/core/Slider";
import { Theme } from "../../../theme";

const StyledSection = styled.section`
  padding-left: 24px;
  /* border: 1px solid black; */
  margin-top: -8px;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: 8px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;

  .cardTitle {
    margin-top: -4px;
    font-weight: 700px;
    font-size: 16px;
  }
  .cardTime {
    margin-left: 16px;
  }

  .spacer {
    flex: 1;
  }
  .slider {
    margin-top: 10px;
    margin-left: 16px;
    margin-right: 16px;
    height: 100%;
    width: 100px;
  }

  .switch {
    margin-top: 4px;
    flex-grow: 0;
  }
`;

export interface CameraHeaderProps {
  heatmapActive: boolean;
  toggleSwitch: () => void;
  location: string;
  riskColor: string;
  timestamp: Date;
  sliderValue: number;
  handleSliderChange: (
    event: React.ChangeEvent<{}>,
    newValue: number | number[]
  ) => void;
}

//Layout is determined here
const CameraHeader: React.FC<CameraHeaderProps> = props => {
  const theme: Theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <StyledSection style={{ backgroundColor: props.riskColor }}>
        <div className="cardTitle">
          <p>{props.location}</p>
        </div>
        <div className="cardTime">
          <p>
            {props.timestamp.toDateString()} :{" "}
            {props.timestamp.toLocaleTimeString()}
          </p>
        </div>
        <div className="spacer"></div>
        {mdUp && (
          <div className="slider">
            <Slider
              value={props.sliderValue}
              onChange={props.handleSliderChange}
              aria-labelledby="continuous-slider"
            />
          </div>
        )}
        <div>
          <p>Toggle Heatmap</p>
        </div>
        <div className="switch">
          <Switch
            checked={props.heatmapActive}
            onChange={props.toggleSwitch}
            value="heatmapActive"
            inputProps={{ "aria-label": "secondary checkbox" }}
          />
        </div>
      </StyledSection>
    </>
  );
};

export default CameraHeader;
